"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CommunicationMethodsPrompt = void 0;

var _Promptable = _interopRequireDefault(require("UIComponents/decorators/Promptable"));

var _CommunicationMethodsModal = _interopRequireDefault(require("ui-addon-upgrades/_core/communicationMethods/CommunicationMethodsModal"));

var _PromiseHandlers = require("UIComponents/core/PromiseHandlers");

var CommunicationMethodsPrompt = function CommunicationMethodsPrompt(propsToPass) {
  var _prompt = (0, _Promptable.default)(_CommunicationMethodsModal.default);

  return _prompt(propsToPass).catch(_PromiseHandlers.rethrowError);
};

exports.CommunicationMethodsPrompt = CommunicationMethodsPrompt;